import './style/adminHeader.scss';

import {ChangeFunction, DVRDSwitch} from '@dvrd/dvr-controls';
import React, {MouseEventHandler, useContext} from 'react';
import {ContentMode} from '../../../util/enums';
import {ContentContext} from '../../context/contentContext';

interface Props {
    onToggleMode: ChangeFunction<boolean>;
    onClickLogout: MouseEventHandler;
    onClickPublish: MouseEventHandler;
    onNavigateAdmin: MouseEventHandler;
}

export default function AdminHeader(props: Props) {
    const {contentMode} = useContext(ContentContext);
    const {onToggleMode, onClickLogout, onClickPublish, onNavigateAdmin} = props;

    function renderContent() {
        return (
            <>
                <DVRDSwitch value={contentMode === ContentMode.PREVIEW} onChange={onToggleMode}
                            labels={['Preview modus:', '']}/>
                {contentMode === ContentMode.PREVIEW && (
                    <div className='btn btn-publish' onClick={onClickPublish}>
                        <label>Publiceren</label>
                    </div>
                )}
            </>
        );
    }

    function renderLogout() {
        return (
            <div className='nav-container'>
                <label className='btn' onClick={onNavigateAdmin}>Documenten</label>
                <label className='btn btn-logout' onClick={onClickLogout}>Uitloggen</label>
            </div>
        );
    }

    return (
        <div className='admin-header'>
            {renderContent()}
            {renderLogout()}
        </div>
    );
}

AdminHeader.displayName = 'AdminHeader';